import React, { createContext, useContext } from "react";

export type RuntimeConfig = {
	version: string;
	publicPath: string;
	rootUrl: string;
	i18n: {
		locales: string[];
		defaultLocale: string;
	};
};

export const RuntimeContext = createContext<RuntimeConfig | null>(null);

export const useRuntimeConfig = (): RuntimeConfig => {
	const runtime = useContext(RuntimeContext);

	if (!runtime) {
		throw new Error("RuntimeProvider is missing from the component tree.");
	}

	return runtime;
};

export type RuntimeProviderProps = {
	runtime: RuntimeConfig;
};

export const RuntimeProvider = ({ runtime, children }: React.PropsWithChildren<RuntimeProviderProps>) => (
	<RuntimeContext.Provider value={runtime}>{children}</RuntimeContext.Provider>
);
